var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "300 300 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{display:inline;}\r\n\t.st2{display:inline;clip-path:url(#SVGID_2_);}\r\n\t.st3{clip-path:url(#SVGID_4_);fill:#565656;}\r\n\t.st4{fill:#E6FF0A;}\r\n\t.st5{fill:#4A89AF;}\r\n\t.st6{opacity:0.34;fill:url(#SVGID_5_);enable-background:new;}\r\n\t.st7{opacity:0.34;fill:url(#SVGID_6_);enable-background:new;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M619.3,470.3c4-3.6,6-5.3,10-8.8C626.6,463.9,623.2,466.8,619.3,470.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M683.4,380.9c-23.6-9.4-35.7-13.5-60.6-19.9c-19.1-5-39-5.5-57.7-0.6c-9.6,2.5-19,6.3-24.9,11.4 c-10.8,9.3-22.9,20.6-33,31.1c-2,2.1-4.6,3.1-7.2,3c-2.6,0.1-5.2-0.9-7.2-3c-10.1-10.5-22.1-21.9-33-31.1c-6-5.1-15.3-9-24.9-11.4 c-18.7-4.8-38.6-4.3-57.7,0.6c-24.9,6.5-37,10.5-60.6,19.9c-2.1,0.8-3.9,2.3-5.3,4.1c1-0.9,2.3-1.3,3.5-1.1 c23.2,3.5,55.3,19.4,55.3,19.4c-0.4-0.2-0.6-0.4-1-0.6c0,0,3.4,1.9,5.2,3c16.1,9.6,26.6,17.8,37.4,27.6 c28.3,25.7,54.2,54.2,79.4,82.9c2.5,2.8,5.7,4.2,8.9,4.2c3.2,0,6.4-1.4,8.9-4.2c25.2-28.7,51.1-57.2,79.4-82.9 c10.8-9.8,21.3-18.1,37.4-27.6c1.8-1.1,5.2-3,5.2-3c-0.4,0.2-0.6,0.4-1,0.6c0,0,32.1-15.9,55.3-19.4c1.2-0.2,2.5,0.2,3.5,1.1 C687.3,383.2,685.5,381.8,683.4,380.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M380.7,470.3c-4-3.6-6-5.3-10-8.8C373.4,463.9,376.8,466.8,380.7,470.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M697.1,421.5c-0.2-1.4-0.3-2.8-0.5-4.2c-0.1-1.2-0.3-2.5-0.5-3.7c-1.1-7.9-2.5-15.8-4.7-23.5c0,0,0-0.1-0.1-0.1 c-0.5-1.8-1.4-3.5-2.6-4.9c-1-0.9-2.3-1.3-3.5-1.1c-23.2,3.5-36,8.5-55.3,19.4c-1.4,0.8-2.8,1.6-4.2,2.4c1.3,2.2,2.5,4.1,3.5,5.9 c0.4,0.6,0.7,1.1,1.1,1.7c1.3,2,2.4,3.9,3.7,6c0.4,0.6,0.8,1.2,1.2,1.8c0.4,0.6,0.8,1.3,1.3,2c0.4,0.7,0.9,1.4,1.4,2.1 c4.3,6.7,4.5,13.5,4.4,16.8c-0.1,3.4-1,9.3-5.3,13c-0.1,0.1-0.3,0.3-0.4,0.4c-0.4,0.3-0.6,0.5-1,0.8v0.1c-1.4,1.1-3.4,2.8-6.1,5.1 c-4,3.5-6,5.2-10,8.8C591,496,565,524.3,539.9,553c-8.4,9.7-13.2,23.3-13,37.6c0.1,6.8,0.2,14.7,0.3,23.3 c0.3,24.5,28.7,38.1,43.6,22.5c36-37.5,72.2-75,108.8-111.8c13.8-13.8,18.4-35,19.1-59.9c0-0.2,0-0.3,0-0.6 C699.1,450.2,698.6,435.7,697.1,421.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M380.7,470.3c-4-3.6-6-5.3-10-8.8c-2.6-2.2-4.7-4-6.1-5.1c0,0,0,0,0-0.1c-0.4-0.3-0.6-0.5-1-0.8 c-0.2-0.1-0.3-0.3-0.4-0.4c-4.3-3.7-5.2-9.6-5.3-13c-0.1-3.3,0.1-10.1,4.4-16.8c0.5-0.7,0.9-1.5,1.4-2.1c0.5-0.7,0.8-1.4,1.3-2 c0.4-0.7,0.8-1.3,1.2-1.8c1.3-2.1,2.5-4,3.7-6c0.4-0.6,0.7-1.1,1-1.7c1.1-1.8,2.2-3.6,3.5-5.9c-1.5-0.8-2.9-1.7-4.2-2.4 c-19.3-10.9-32.1-15.9-55.3-19.4c-1.2-0.2-2.5,0.2-3.5,1.1c-1.1,1.4-2,3.1-2.6,4.9c0,0,0,0.1-0.1,0.1c-2.2,7.7-3.6,15.6-4.7,23.5 c-0.2,1.2-0.4,2.5-0.5,3.7c-0.2,1.4-0.3,2.8-0.5,4.2c-1.5,14.1-2.1,28.7-1.7,42.5c0,0.2,0,0.4,0,0.6c0.8,24.9,5.4,46.1,19.1,59.9 c36.7,36.8,72.8,74.3,108.8,111.8c14.9,15.6,43.4,2,43.6-22.5c0.1-8.6,0.2-16.5,0.3-23.3c0.2-14.3-4.6-27.9-13-37.6 C435,524.3,408.9,496.1,380.7,470.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.9828,
    y1: 568.7585,
    x2: 650.496,
    y2: 597.4155,
    gradientTransform: "matrix(1 0 0 -1 0 999.28)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M691.4,390.1c0,0,0-0.1-0.1-0.1c-0.5-1.8-1.4-3.5-2.6-4.9c-1-0.9-2.3-1.3-3.5-1.1c-23.2,3.5-36,8.5-55.3,19.4 c-1.4,0.8-2.8,1.6-4.2,2.4c1.3,2.2,2.5,4.1,3.5,5.9c0.4,0.6,0.7,1.1,1.1,1.7c1.3,2,2.4,3.9,3.7,6c0.4,0.6,0.8,1.2,1.2,1.8 c0.4,0.6,0.8,1.3,1.3,2c0.4,0.7,0.9,1.4,1.4,2.1c4.3,6.7,4.5,13.5,4.4,16.8c-0.1,3.4-1,9.3-5.3,13c18.9-15.7,38.7-29.7,59.2-41.6 C695,405.7,693.6,397.8,691.4,390.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.8384,
    y1: 570.6051,
    x2: 350.6537,
    y2: 601.2082,
    gradientTransform: "matrix(1 0 0 -1 0 999.28)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M308.6,390.1c0,0,0-0.1,0.1-0.1c0.5-1.8,1.4-3.5,2.6-4.9c1-0.9,2.3-1.3,3.5-1.1c23.2,3.5,36,8.5,55.3,19.4 c1.4,0.8,2.8,1.6,4.2,2.4c-1.3,2.2-2.5,4.1-3.5,5.9c-0.4,0.6-0.7,1.1-1,1.7c-1.3,2-2.4,3.9-3.7,6c-0.4,0.6-0.8,1.2-1.2,1.8 c-0.4,0.6-0.8,1.3-1.3,2c-0.4,0.7-0.9,1.4-1.4,2.1c-4.3,6.7-4.5,13.5-4.4,16.8c0.1,3.4,1,9.3,5.3,13c-18.9-15.7-38.7-29.7-59.2-41.6 C305,405.7,306.4,397.8,308.6,390.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimary);
export default __webpack_public_path__ + "static/media/logo-primary.e5a8677fcbdd7320123fbb7fc1121d16.svg";
export { ForwardRef as ReactComponent };